import React, { ComponentProps, FC, MouseEvent } from 'react';
import styled, { css } from 'styled-components';

import { ButtonWrapper } from '../Button';
import { Icon } from '../Icon';

export type IconButtonProps = ComponentProps<typeof Icon> & {
  testId?: string;
  isDisabled?: boolean;
  onClick: (event: MouseEvent<HTMLButtonElement>) => void;
  spacing?: string;
};

export const IconButton: FC<IconButtonProps> = ({
  testId,
  isInverted,
  className,
  onClick,
  spacing,
  isDisabled = false,
  ...iconProps
}) => (
  <IconButtonWrapper
    data-test-id={testId}
    className={className}
    isInverted={isInverted}
    onClick={onClick}
    disabled={isDisabled}
    spacing={spacing}
  >
    <Icon isInverted={isInverted} {...iconProps} />
  </IconButtonWrapper>
);

export const IconButtonWrapper = styled(ButtonWrapper)<{ spacing?: string }>`
  display: inline-flex;
  border-radius: 50%;
  padding: ${({ spacing }) => spacing ?? '0.25em'};
  min-width: auto;

  &:hover,
  &:focus {
    background-color: #fff; /* TODO: theme */
  }

  ${({ isInverted }) =>
    isInverted &&
    css`
      &:hover,
      &:focus {
        background-color: #000; /* TODO: theme */
      }
    `}

  &:disabled {
    background-color: inherit;
  }
`;
